// Respawn anchor (M20.1). PURE (ENG-1): the charge machine and the
// dimension-gated use. Glowstone charges the anchor (0..MAX); in the Nether a
// charged anchor sets the player's spawn and spends a charge, but ANYWHERE else a
// charged anchor detonates like a bed. Respawning at it spends a charge.
import { ANCHOR } from '../config';

/** Add a glowstone charge, capped at the maximum. */
export function chargeAnchor(current: number): number {
  return Math.min(ANCHOR.MAX_CHARGES, Math.max(0, Math.floor(current)) + 1);
}

/** Whether the anchor still has room for another glowstone charge. */
export function canCharge(current: number): boolean {
  return Math.floor(current) < ANCHOR.MAX_CHARGES;
}

export type AnchorAction = 'charge' | 'set_spawn' | 'explode' | 'none';

/**
 * What right-clicking the anchor does. Holding glowstone charges it (any
 * dimension) while it has room. Otherwise a charged anchor sets the player's spawn
 * in the Nether, or explodes in any other dimension; an uncharged anchor with an
 * empty hand does nothing.
 */
export function anchorAction(dimension: string, charges: number, holdingGlowstone: boolean): AnchorAction {
  if (holdingGlowstone && canCharge(charges)) return 'charge';
  if (Math.floor(charges) <= 0) return 'none';
  return dimension === 'nether' ? 'set_spawn' : 'explode';
}

/** Respawning at the anchor spends one charge (never below zero). */
export function depleteOnRespawn(charges: number): number {
  return Math.max(0, Math.floor(charges) - 1);
}

/** Explosion power of a detonating (wrong-dimension) respawn anchor. */
export function anchorExplosionPower(): number {
  return ANCHOR.EXPLOSION_POWER;
}
